/* global __CONFIG__ */
import fetch from 'axios';
import { postApi } from '@coconut/services/apis/utils';

const { SNAPASK_LANDING_ROOT_PATH } = __CONFIG__;

export const appLaunch = (lang) =>
  postApi('api/v2/app_launch', {
    data: {
      lang,
    },
  }).then((res) => res);

export const syncUserToZendesk = () => postApi('api/v3/users/zendesk_attrs');

export const submitTicketToZendesk = ({
  name,
  email,
  userId,
  role,
  region,
  message,
  studentId,
  tutorId,
  chatroomId,
  tokens,
  projectName,
  subjectTitle,
}) => {
  return fetch(`${SNAPASK_LANDING_ROOT_PATH}/submitTicketToZendesk`, {
    method: 'POST',
    data: {
      name,
      email,
      userId,
      role,
      region,
      message,
      studentId,
      tutorId,
      chatroomId,
      tokens,
      projectName,
      subjectTitle,
    },
  }).catch((err) => {
    throw new Error(err);
  });
};

export const uploadFileToZendesk = (file) => {
  const data = new FormData();
  if (file) data.append('file', file);

  return fetch(`${SNAPASK_LANDING_ROOT_PATH}/upload`, {
    method: 'POST',
    data,
  })
    .then((res) => res.data.upload)
    .catch((err) => {
      throw new Error(err);
    });
};



// WEBPACK FOOTER //
// ./src/services/apis/report.js